import { createFileRoute, Navigate } from '@tanstack/react-router'
import { PfMessagesTab, useSettingsDraft } from '@/features/settings'

/**
 * C-14 "PF internal message notification" (task 24, D-81). Only while a super admin has the feature on
 * (`pfMessages.enabled`); otherwise the URL opens the Booking map.
 */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings/notifications')({
  component: function NotificationsRoute() {
    const { clinicId } = Route.useParams()
    const { base } = useSettingsDraft()
    if (!base.pfMessages.enabled) {
      return <Navigate to="/clinics/$clinicId/settings/booking/map" params={{ clinicId }} replace />
    }
    return <PfMessagesTab />
  },
})
